import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal, SectionHeader } from "./Reveal";

const STEPS = [
  {
    num: "01",
    title: "Create Account",
    desc: "Register or log in to your CDM Pay account.",
    testid: "how-it-works-step-1",
  },
  {
    num: "02",
    title: "Create Exchange Order",
    desc: "Enter the USDT amount you want to exchange and review the applicable INR calculation.",
    testid: "how-it-works-step-2",
  },
  {
    num: "03",
    title: "Complete Payment Process",
    desc: "Follow the payment instructions displayed for your order and complete the required cash deposit/payment process.",
    testid: "how-it-works-step-3",
  },
  {
    num: "04",
    title: "Receive INR",
    desc: "After the required verification and processing, the INR payment will be processed according to the order details.",
    testid: "how-it-works-step-4",
  },
];

export default function HowItWorks() {
  return (
    <section id="how-it-works" data-testid="how-it-works-section" className="section-pad relative">
      <div
        aria-hidden="true"
        className="absolute left-0 top-1/3 h-[380px] w-[380px] rounded-full bg-teal-500/[0.06] blur-[110px]"
      />
      <div className="container-x relative">
        <SectionHeader
          testid="how-it-works"
          eyebrow="How It Works"
          title="Exchange in four simple steps"
          sub="From account creation to receiving INR — every order follows a clear, guided process."
        />

        <div className="relative mt-16 grid gap-6 sm:gap-8 md:grid-cols-2 lg:grid-cols-4">
          <div
            aria-hidden="true"
            className="absolute left-0 right-0 top-6 hidden h-px bg-gradient-to-r from-transparent via-emerald-500/30 to-transparent lg:block"
          />
          {STEPS.map(({ num, title, desc, testid }, i) => (
            <Reveal key={num} delay={i * 0.1}>
              <div
                data-testid={testid}
                className="group glass-card relative h-full p-6 transition-all duration-300 hover:-translate-y-1.5 hover:border-emerald-400/30 hover:shadow-glow-sm sm:p-7"
              >
                <div className="relative z-10 mb-6 grid h-12 w-12 place-items-center rounded-full border border-emerald-400/30 bg-[#0B1120] font-mono text-sm font-semibold text-emerald-300">
                  {num}
                </div>
                <h3 className="font-display text-lg font-semibold tracking-tight text-white sm:text-xl">
                  {title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-slate-400">{desc}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.15}>
          <div className="mt-14 text-center" data-testid="how-it-works-cta">
            <Link
              to="/app"
              onClick={() =>
                sessionStorage.setItem("cdm-scroll", String(window.scrollY))
              }
              className="btn-primary px-8 py-4 text-base"
            >
              Login &amp; Create Your Order
              <ArrowRight className="h-5 w-5" />
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
